import { Theme } from "@mui/material/styles";
import { SystemStyleObject, alpha } from "@mui/system";

const sectionLinksStyles = {
  box: (): SystemStyleObject<Theme> => ({
    display: "grid",
    gridTemplateColumns: {
      xs: "1fr",
      md: "repeat(2, 1fr)",
      lg: "repeat(4, 1fr)",
    },
    gridGap: 6,
    mb: 2,
  }),
  link: (theme: Theme): SystemStyleObject<Theme> => ({
    backgroundColor: theme.palette.background.paper,
    borderRadius: 0,
    p: 2,

    display: "flex",
    gap: 2,
    alignItems: "center",
  }),
  button: (theme: Theme): SystemStyleObject<Theme> => ({
    borderRadius: 0,
    position: "relative",
    display: "inline-flex",
    color: theme.palette.text.primary,

    "&:hover, &:focus": {
      color: alpha(theme.palette.text.primary, 0.6),
      background: "none",
    },

    "&:after": {
      content: "''",
      width: "95%",
      height: "1px",
      position: "absolute",
      bottom: 0,
      left: 0,
      background: "currentColor",
    },
  }),
};

export default sectionLinksStyles;
